export const CONS = {
  'hostUrl': 'https://admin.magyarpszichodrama.hu',
  'devHostUrl': 'https://admin.magyarpszichodrama.hu',
  'adminVersion': '/api/v1.0',
}

if ( process.env.NODE_ENV === 'development' ) {
  CONS.host = CONS.devHostUrl + CONS.adminVersion;
} else {
  CONS.host = CONS.hostUrl + CONS.adminVersion;
}

export default CONS;


// WEBPACK FOOTER //
// ./src/constants.js